import Vue from 'vue';
import jwtDecode from 'jwt-decode';
import VueSession from 'vue-session';
import axios from 'axios';
import swal from 'sweetalert2';
import moment from 'moment';
import bugsnag from 'bugsnag-js';
import bugsnagVue from 'bugsnag-vue';
import linkify from 'vue-linkify';

import App from './App.vue';
import router from './router';



import store from './store/index';

import {
	setSessionUser,
	clearSession
} from './utils/auth';
import eventHub from './utils/eventhub';

const options = {
	persist: true
};

window.swal = swal;

Vue.directive('linkified', linkify);
Vue.use(VueSession, options);
window.moment = moment;

const {
	VUE_APP_BUGSNAG_KEY,
	VUE_APP_NODE_ENV
} = process.env;
const bugsnagClient = bugsnag(VUE_APP_BUGSNAG_KEY);
bugsnagClient.app.releaseStage = VUE_APP_NODE_ENV;
bugsnagClient.use(bugsnagVue(Vue));

window.bugsnagClient = bugsnagClient;
window.errorCode = [404, 403, 409];

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.config.productionTip = false;

router.afterEach((to) => {
	document.title = to.meta.title || 'Next';
});

new Vue({
	router,
	store,
	render: h => h(App),
	data() {
		return {
			userId: this.$session.get('id'),
			loggedIn: store.getters.isLoggedIn
		};
	},
	computed: {
		isLoggedIn() {
			return store.getters.isLoggedIn;
		},
		loggedUser() {
			return store.getters.getLoggedUser;
		}
	},
	watch: {
		isLoggedIn(newValue) {
			if (newValue) {
				this.loggedIn = this.isLoggedIn;
				this.userId = this.loggedUser.id;
				this.startSession(this.loggedUser);
			}
		}
	},
	created() {
		if (this.isLoggedIn) {
			try {
				const token = jwtDecode(eventHub.$session.get('token'));
				const time = Date.now().valueOf() / 1000;
				if (token.exp < time) {
					this.endSession();
				} else {
					this.resumeSession();
				}
			} catch (error) {
				this.endSession();
				return error;
			}
		}
		return true;
	},
	methods: {
		/**
		 * Starts a user session
		 * @param {Object} data - the user's login details and token
		 *
		 */
		startSession(userData) {
			const userCategory = (userData.category !== undefined) ? userData.category.key : '';
			const user = {
				fname: userData.fname,
				lname: userData.lname,
				id: userData.id,
				avatar: userData.avatar,
				category: userCategory,
				alumni: userData.alumni
			};
			this.$session.start();
			this.$session.set('fname', user.fname);
			this.$session.set('lname', user.lname);
			this.$session.set('id', user.id);
			this.$session.set('avatar', user.avatar);
			this.$session.set('category', user.category);
			this.$session.set('token', userData.token);
			this.$session.set('alumni', user.alumni);
			this.$session.set('userData', userData);

			setSessionUser(user);
			axios.defaults.headers.common.token = userData.token;
			store.commit('setLoggedUser', user);
			store.commit('setUserObject', userData);
		},
		/**
		 * Resumes a user session
		 * Uses the user session data to continue that session
		 */
		resumeSession() {
			const user = {
				fname: this.$session.get('fname'),
				lname: this.$session.get('lname'),
				id: this.$session.get('id'),
				avatar: this.$session.get('avatar'),
				category: this.$session.get('category'),
				alumni: this.$session.get('alumni')
			};
			const userData = this.$session.get('userData');
			const token = this.$session.get('token');
			axios.defaults.headers.common.token = token;
			store.commit('setLoggedUser', user);
			store.commit('setUserObject', userData);
		},
		/**
		 * Ends a user session
		 * @param {Object} data - the user's login details and token
		 *
		 */
		endSession() {
			this.$session.clear();
			this.$session.destroy();
			clearSession();
			axios.defaults.headers.common.token = null;
			store.commit('logout');
			setTimeout(() => {
				this.$router.push('/login');
			}, 500);
		}
	}
}).$mount('#app');
const prod = process.env.NODE_ENV === 'production'
const shouldSW = 'serviceWorker' in navigator && prod
if (shouldSW) {
  navigator.serviceWorker.register('/service-worker.js').then(() => {
    console.log("Service Worker Registered!")
  })
}
self.addEventListener('activate', () => {
  self.clients.matchAll({
    type: 'window'
  }).then(clients => {
    for (let client of clients) {
      client.navigate(client.url)
    }
  })
})
